// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  firebaseConfig: {
    apiKey: 'AIzaSyDXO7SaxWZaul_A9qBM0zm_gUfSRK0WEgg',
    authDomain: 'tierra-cervecera-d428d.firebaseapp.com',
    projectId: 'tierra-cervecera-d428d',
    storageBucket: 'tierra-cervecera-d428d.appspot.com',
    messagingSenderId: '1068207094662',
    appId: '1:1068207094662:web:20cf2504bd47b182f18a07',
    measurementId: 'G-MGG199B6D2'
  },
  recaptcha: {
    siteKey: '6LfEOEcfAAAAAKAkKyxHylH3c4dB3WH8yV2ZBXs1'
  },
  production: false
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.

